import { productFamilyIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { restrictionTier } from "./restriction-tier-output";

export const familyRestrictionVariantOutput = z.object({
  productId: z.string(),
  title: z.string(),
  tier: restrictionTier,
  matchHsCode: z.string(),
  confidenceScore: z.number().nullable(),
});

export const familyRestrictionOutput = z.object({
  destinationCountryCode: z.string(),
  tier: restrictionTier,
  category: z.string().nullable(),
  summary: z.string(),
  sourceUrl: z.string().nullable(),
  lastSeenAt: z.date(),
  variants: z.array(familyRestrictionVariantOutput),
});

export const getProductFamilyRestrictions = {
  name: "getProductFamilyRestrictions" as const,
  input: z.object({ productFamilyId: productFamilyIdFormat.schema }),
  output: z.object({
    restrictions: z.array(familyRestrictionOutput),
    lanes: z.array(
      z.object({
        destinationCountryCode: z.string(),
        screenedVariants: z.number(),
        lastScreenedAt: z.date().nullable(),
      }),
    ),
  }),
};
